import React from "react";

/**
 * Context to share the dual band link reference information between all components
 */
 export const DualBandLinkReferenceContext = React.createContext<Readonly<any>>({} as {});

/**
 * Context to share the dual band link information that user has given
 */
 export const DualBandLinkUserContext = React.createContext<Readonly<any>>({} as {});